<template>
    <el-dialog title="评价" :visible="visibleOrder" width="50%" @close="closeDialog"
        :close-on-click-modal="false" append-to-body>
        <div class="container">
            <div class="fixed-cards">
                <!-- 商户报单详情的表单 -->
                <el-card v-if="declarationInfo && declarationInfo.customName" shadow="hover" class="card">
                    <div slot="header" class="clearfix">
                        <span>商户报单信息:</span>
                    </div>
                    <div class="card-content">
                        <el-row>
                            <el-col :span="8"><strong>客户姓名:</strong> {{ declarationInfo.customName }}</el-col>
                            <el-col :span="8"><strong>客户手机号:</strong> {{ declarationInfo.contactMobile || declarationInfo.customMobile }}</el-col>
                            <el-col :span="8"><strong>客户地址:</strong> {{ declarationInfo.customAddress }}</el-col>
                        </el-row>
                    </div>
                </el-card>
                <el-card shadow="hover" class="card">
                    <div slot="header" class="clearfix">
                        <span>评价详情:</span>
                    </div>
                    <div class="card-content">
                        <el-row v-if="dynamicColumns.length > 0">
                            <el-col v-for="column in dynamicColumns" :key="column.id"
                                style="display: flex;align-items: center;text-align: center;"
                                :span="getSpan(dynamicColumns.length)">
                                <strong>{{ column.fieldName }}:</strong>
                                <span v-if="['input', 'checkbox', 'radio'].includes(column.inputType)">{{
                                    column.fieldValue }}</span>
                                <!-- 评分星级 -->
                                <span v-else-if="column.inputType === 'star'"
                                    style="display: flex;align-items: center;text-align: center;">
                                    <el-rate v-model="column.fieldValue" disabled></el-rate>
                                    <span>{{ column.fieldValue == '1' ? '差' : column.fieldValue == '2' ? '一般' :
                                        column.fieldValue == '3' ? '好' : column.fieldValue == '4' ? '很好' :
                                            column.fieldValue
                                                == '5' ? '非常好' : '' }}</span>
                                </span>
                                <span v-else><time>{{ column.fieldValue }}</time></span>
                            </el-col>
                        </el-row>
                        <el-row v-if="dynamicColumns.length === 0">
                            <el-col :span="24">
                                <p>暂无数据</p>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
            </div>
            <div class="dynamic-cards" v-if="imageFields.length > 0">
                <el-card shadow="hover" class="card">
                    <div slot="header" class="clearfix">
                        <span>评价图片信息:</span>
                    </div>
                    <div class="form-row" v-for="column in imageFields" :key="column.id">
                        <p class="gap-line-border" v-if="column.inputType === 'img'">
                            <span class="nameStyle">{{ column.fieldName }}:</span>
                            <span class="gap-line"></span>
                            <span v-if="column.fieldValue">
                                <viewer :images="formmaterImage(column.fieldValue)">
                                    <img v-for="src in formmaterImage(column.fieldValue)" :src="src" :key="src"
                                        class="card-image" />
                                </viewer>
                            </span>
                            <span v-else>暂无图片</span>
                        </p>
                    </div>
                </el-card>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">关闭</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { evaluateInfoView } from "@/api/salesCloud/preFilter";
import { findDataSourceFields } from "@/api/work/dynamicForm";
export default {
    name: "ViewWaterProofEvaluation",
    props: {
        visibleOrder: {
            type: Boolean,
            required: true,
        },
        orderId: {
            type: [String, Number],
            required: true,
        },
        declarationInfo: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            dynamicColumns: [], // 存放动态字段列数据
            imageFields: [], // 存放动态图片字段数据
            inputTypes: [], // 获取动态控件类型
        };
    },
    created() {
        // 初始加载时如果 orderId 已经有值，调用 handleList
        if (this.orderId) {
            findDataSourceFields().then(res => {
                let data = JSON.parse(res.data);
                this.inputTypes = data;
                if (this.orderId) {
                    this.fetchEvaluationData(this.orderId);
                }
            }).catch(err => {
                this.$message.error('获取动态控件类型失败', err);
            });
        }
    },
    watch: {
        /**
         * @param newVal
         * @description 监听 visibleOrder 的变化
         * @returns void
         */
        visibleOrder(newVal) {
            if (newVal && this.orderId) {
                findDataSourceFields().then(res => {
                    let data = JSON.parse(res.data);
                    this.inputTypes = data;
                    if (this.orderId) {
                        this.fetchEvaluationData(this.orderId);
                    }
                }).catch(err => {
                    this.$message.error('获取动态控件类型失败', err);
                });
            }
        }
    },
    methods: {
        /**
         * @param orderId 工单ID
         * @description 获取防水评价数据
         * @returns void
         */
        fetchEvaluationData(orderId) {
            const params = {
                id: orderId,
                code: 'WATERPROOF_EVALUATION'
            };
            evaluateInfoView(params).then(res => {
                if (res.code == "200") {
                    const jsonData = JSON.parse(res.data); // 解析返回的 JSON 数据
                    console.log('111',jsonData)
                    // 将图片字段单独处理
                    const imageFields = jsonData.list.filter(item => item.inputType == '8').map(item => ({
                        id: item.id,
                        fieldName: item.fieldName,
                        inputType: this.getInputType(item.inputType),
                        fieldValue: item.value
                    }));
                    this.imageFields = imageFields;
                    // 其他字段
                    const dynamicColumns = jsonData.list.filter(item => item.inputType != '8').map(item => ({
                        id: item.id,
                        fieldName: item.fieldName,
                        inputType: this.getInputType(item.inputType),
                        fieldValue: item.dataType.word == 'star' ? parseInt(item.value) : item.value
                    }));
                    this.dynamicColumns = dynamicColumns;
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error"
                    });
                }
            }).catch(err => {
                this.$message.error('获取数据失败', err);
            });
        },
        /**
         * @param length
         * @description 动态计算每列的span值
         * @returns number
         */
        getSpan(length) {
            return Math.floor(24 / Math.min(length, 3)); // 最多3列
        },
        /**
         * @param row
         * @description 格式化图片字段
         * @returns Array
         */
        formmaterImage(row) {
            let str = new Array();
            if (row != null) {
                let picArray = row.split(",");
                for (let i = 0; i < picArray.length; i++) {
                    str.push(picArray[i]);
                }
            }
            return str;
        },
        /**
         * @param inputType
         * @description 获取输入类型的名称
         * @returns string
         */
        getInputType(inputType) {
            const item = this.inputTypes.find(type => type.id == inputType);
            return item ? item.word : '';
        },
        /**
         * @description 关闭弹窗
         * @returns void
         */
        closeDialog() {
            // 清空所有数据，确保下次打开时不会显示旧数据
            this.dynamicColumns = [];
            this.imageFields = [];
            this.$emit("update:visibleOrder", false);
        }
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    min-height: 80%;
    box-sizing: border-box;
    font-family: fangsong;
    font-size: large;
}

.fixed-cards,
.dynamic-cards {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}

.clearfix {
    font-weight: bold;
}

.gap-line-border {
    padding: 0 10px;
    border: 1px dashed #ccc;
}

.gap-line {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: #ccc;
    margin-top: 10px;
}

.nameStyle {
    font-weight: bold;
    line-height: 4px;
}

.card {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
}

.card:hover {
    transform: scale(1.01);
}

.dynamic-cards:last-child {
    margin-bottom: 30px;
}

.card-content {
    padding: 20px;
    font-family: fangsong;
    word-break: break-word;
}

.card p {
    margin: 10px 0;
    line-height: 1.6;
    word-break: break-word;
}

.card strong {
    color: #333;
}

.card .el-image {
    border-radius: 5px;
}

.card-image {
    width: 100px;
    height: 100px;
    margin: 5px;
    border-radius: 5px;
    border: 1px solid #ccc;
    cursor: pointer;
    transition: transform 0.3s ease;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.form-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 10px;
}

.form-row p {
    flex: 1;
    min-width: calc(20% - 10px);
    box-sizing: border-box;
    margin: 0;
}

.dynamic-cards .card {
    width: 100%;
}
</style>
